// extracted by css-extract-rspack-plugin
export default {"FooterRedesignOffset":"ArtifactRegistryIndex-module__FooterRedesignOffset__MWnur","NavPane":"ArtifactRegistryIndex-module__NavPane__oaxOC"};